module.exports = __webpack_public_path__ + "img/MX.7daee3b4.svg";